import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"; // ✅ for edit mode
import { Row, Col, Form, Button, Table, Spinner } from "react-bootstrap";
import Card from "../../../components/Card";
import {
    API_MANAGE_GROUP_LISTING,
    API_MANAGE_LOCATIONS_LIST,
    API_TRUNKS_LIST,
    API_MANAGE_DIALER_CREATE,
    API_MANAGE_DIALER_DETAIL,   // ✅ GET single dialer
    API_MANAGE_DIALER_UPDATE,   // ✅ UPDATE dialer
    API_SERVER_MANAGEMENT_LIST,
} from "../../../service/url";
import { getApiCall } from "../../../service/getApiCall";
import { postApiCall } from "../../../service/postApiCall";
import { toast } from 'react-toastify';

const CreateDialer = () => {
    const { id } = useParams(); // ✅ check if edit mode
    const isEditMode = !!id;
    const navigate = useNavigate();

    const [groups, setGroups] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState("");
    const [addedGroups, setAddedGroups] = useState([]);

    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState("");

    const [trunks, setTrunks] = useState([]);
    const [selectedTrunk, setSelectedTrunk] = useState("");
    const [servers, setServers] = useState([]);
    const [selectedServer, setSelectedServer] = useState("");

    const [dialerName, setDialerName] = useState("");
    const [ip, setIp] = useState("");
    const [port, setPort] = useState("");

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    // ✅ Fetch groups, locations, trunks
    useEffect(() => {
        const fetchMetaData = async () => {
            try {
                const [groupsData, locationsData, trunksData, serversData] = await Promise.all([
                    getApiCall(API_MANAGE_GROUP_LISTING, {}),
                    getApiCall(API_MANAGE_LOCATIONS_LIST, {}),
                    getApiCall(API_TRUNKS_LIST, {}),
                    getApiCall(API_SERVER_MANAGEMENT_LIST, {})
                ]);

                setGroups(groupsData || []);
                setLocations(locationsData || []);
                setTrunks(trunksData || []);
                setServers(serversData || []);
            } catch (error) {
                console.error("Error fetching groups/locations/trunks:", error);
            }
        };

        fetchMetaData();
    }, []);

    // ✅ If editing, fetch dialer details
    useEffect(() => {
        if (id) {
            setLoading(true);
            getApiCall(API_MANAGE_DIALER_DETAIL(id), {})
                .then((res) => {
                    if (res) {
                        setDialerName(res.dialer_name || "");
                        setIp(res.ip || "");
                        setPort(res.port?.toString() || "");
                        setSelectedLocation(res.location_id?.toString() || "");
                        setSelectedTrunk(res.trunk_id?.toString() || "");
                        setAddedGroups(res.groupMappings?.map((gm) => gm.group) || []);
                        setSelectedServer(res.server_id || "");
                    }
                })
                .catch((err) => console.error("Error fetching dialer:", err))
                .finally(() => setLoading(false));
        }
    }, [id]);

    // ✅ Add selected group
    const handleAddGroup = () => {
        if (!selectedGroup) return;

        const exists = addedGroups.find((g) => g.group_id === parseInt(selectedGroup));
        if (exists) return;

        const groupToAdd = groups.find((g) => g.group_id == selectedGroup);

        if (groupToAdd) {
            setAddedGroups([...addedGroups, groupToAdd]);
            setSelectedGroup("");
        }
    };

    // ✅ Remove group
    const handleRemoveGroup = (gid) => {
        setAddedGroups(addedGroups.filter((g) => g.group_id !== gid));
    };

    // ✅ Create or Update
    const handleSubmit = async (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!dialerName) newErrors.dialerName = "PBX Name is required";
        if (!ip) newErrors.ip = "IP is required";
        if (!port) newErrors.port = "Port is required";
        if (!selectedLocation) newErrors.location = "Location is required";
        if (!selectedTrunk) newErrors.trunk = "Trunk is required";
        if (addedGroups.length === 0) newErrors.groups = "Select at least one group ";
        if (!selectedServer) newErrors.server = "Gateway is required";

        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) return;

        const payload = {
            dialer_name: dialerName,
            ip,
            port: parseInt(port, 10),
            location_id: parseInt(selectedLocation, 10),
            trunk_id: parseInt(selectedTrunk, 10),
            groups: addedGroups.map((g) => Number(g.group_id)),
            server_id: selectedServer
        };

        try {
            if (id) {
                const response = await postApiCall(API_MANAGE_DIALER_UPDATE(id), payload)
                if (response) {
                    toast.success("PBX updated successfully");
                }

            } else {
                const response = await postApiCall(API_MANAGE_DIALER_CREATE, payload);
                if (response) {
                    toast.success("PBX created successfully");
                }
            }

            navigate("/dialer-list");
        } catch (error) {
            console.error("Error saving dialer:", error);
            toast.error(error?.message || error || "Failed to save dialer");
        }
    };

    if (loading) return <Spinner animation="border" />;

    return (
        <div>
            <Row>
                <Col xl="12" lg="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">{id ? "Edit PBX" : "Create PBX"}</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                {/* Dialer info */}
                                <Row className="mb-3">
                                    <Col md={4}>
                                     <Form.Label >PBX Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="PBX Name"
                                            value={dialerName}
                                            disabled={isEditMode}
                                            readOnly={isEditMode}
                                           onChange={(e) => {
    const val = e.target.value;
    if (/^[a-zA-Z0-9]*$/.test(val)) {
        setDialerName(val);
        if (errors.dialerName) {
            setErrors((prev) => ({ ...prev, dialerName: null }));
        }
    }
}}

                                            onKeyDown={(e) => {
                                                if (e.key === " ") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            isInvalid={!!errors.dialerName}
                                        />
                                        {errors.dialerName && <div className="text-danger">{errors.dialerName}</div>}
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label >IP: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
<Form.Control
  type="text"
  placeholder="IP"
  value={ip}
  disabled={isEditMode}
  readOnly={isEditMode}
  onChange={(e) => {
    const val = e.target.value;
    if (/^[0-9.]*$/.test(val)) {
      setIp(val);
      if (errors.ip) {
        setErrors((prev) => ({ ...prev, ip: null }));
      }
    }
  }}
  onBlur={() => {
    const ipRegex =
      /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;

    if (ip && !ipRegex.test(ip)) {
      setErrors((prev) => ({ ...prev, ip: "Invalid IPv4 address" }));
    }
  }}
  isInvalid={!!errors.ip}
/>
                                        {errors.ip && <div className="text-danger">{errors.ip}</div>}
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label >Port: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                        <Form.Control
  type="text"
  placeholder="Port"
  value={port}
  disabled={isEditMode}
  readOnly={isEditMode}
  maxLength={5}
  onChange={(e) => {
    const val = e.target.value.replace(/\D/g, "");

    if (val.length <= 5) {
      setPort(val);
      if (errors.port) {
        setErrors((prev) => ({ ...prev, port: null }));
      }
    }
  }}
  onBlur={() => {
    if (!port || port.length > 5) {
      setErrors((prev) => ({ ...prev, port: "Port must be numeric and max 5 digits" }));
    }
  }}
  isInvalid={!!errors.port}
/>
                                        {errors.port && <div className="text-danger">{errors.port}</div>}
                                    </Col>
                                </Row>

                                {/* Groups */}
                                <Row className="mb-3 align-items-center">
                                    <Col md={11}>
                                     <Form.Label >Select Group: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                        <Form.Select
                                            value={selectedGroup}
                                            onChange={(e) => setSelectedGroup(e.target.value)}
                                            isInvalid={!!errors.groups && addedGroups.length === 0}
                                        >
                                            <option value="">Select Group</option>
                                            {groups
                                            .filter(
                                                (g) => !addedGroups.some((ag) => ag.group_id == g.group_id)
                                            )
                                            .map((g) => (
                                                <option key={g.group_id} value={g.group_id}>
                                                    {g.group_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                    <Col md={1} className="d-flex justify-content-center">
                                        <Button
                                            variant="dark"
                                            className="rounded-circle p-0"
                                            style={{ width: "36px", height: "36px" }}
                                            onClick={handleAddGroup}
                                            type="button"
                                        >
                                            +
                                        </Button>
                                    </Col>
                                </Row>
                                {errors.groups && <div className="text-danger mb-2">{errors.groups}</div>}

                                {/* Groups Table */}
                                <Row className="mb-3">
                                    <Col md={12}>
                                        <Table bordered responsive>
                                            <thead>
                                                <tr>
                                                    <th>Group</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {addedGroups.length > 0 ? (
                                                    addedGroups.map((g) => (
                                                        <tr key={g.group_id}>
                                                            <td>{g.group_name}</td>
                                                            <td>
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => handleRemoveGroup(g.group_id)}
                                                                >
                                                                    Remove
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="2" className="text-center">
                                                            No groups added
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>

                                {/* Trunk + Location */}
                                <Row className="mb-3">
                                    <Col md={6}>
                                     <Form.Label >Select Trunk: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                        <Form.Select
                                            value={selectedTrunk}
                                            onChange={(e) => setSelectedTrunk(e.target.value)}
                                            isInvalid={!!errors.trunk}
                                            disabled={isEditMode}
                                            readOnly={isEditMode}
                                        >
                                            <option value="">Select Trunk</option>
                                            {trunks.map((t) => (
                                                <option key={t.id} value={t.id}>
                                                    {t.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.trunk && <div className="text-danger">{errors.trunk}</div>}
                                    </Col>
                                    <Col md={6}>
                                     <Form.Label >Select Location: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                        <Form.Select
                                            value={selectedLocation}
                                            onChange={(e) => setSelectedLocation(e.target.value)}
                                            isInvalid={!!errors.location}
                                        >
                                            <option value="">Select Location</option>
                                            {locations.map((loc) => (
                                                <option key={loc.location_id} value={loc.location_id}>
                                                    {loc.location_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.location && <div className="text-danger">{errors.location}</div>}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <Form.Label >Select Gateway: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                        <Form.Select
                                            value={selectedServer}
                                            onChange={(e) => setSelectedServer(e.target.value)}
                                            isInvalid={!!errors.server}
                                            disabled={isEditMode}
                                            readOnly={isEditMode}
                                        >
                                            <option value="">Select Gateway</option>
                                            {servers.map((ser) => (
                                                <option key={ser.id} value={ser.id}>
                                                    {ser.server_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.server && <div className="text-danger">{errors.server}</div>}
                                    </Col>
                                </Row>

                                <Button variant="primary" type="submit">
                                    {id ? "Update" : "Create PBX"}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default CreateDialer;
